import { SVGGroup } from '@pff-consumer/utils/lib/svg/svg-group'

export const PAYPAL_OPTS = {
  display: { displayName: 'PFF+ Subscription' },
  braintree: { clientAuthorization: process.env.BRAINTREE_CLIENT_KEY! },
}

export const appleIconProps = {
  iconWidth: 24,
  iconHeight: 28,
  iconName: 'apple',
  text: 'Pay',
}

export const creditCardIconProps = {
  iconName: 'credit-card',
  iconGroup: SVGGroup.Icons,
  iconHeight: 18,
  iconWidth: 24,
}
